/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useRef, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../../component/Pagination";
import { getIngredient } from "../../dish/core/_requests";
import EditIngredient from "./EditIngredient";
import AddIngredient from "./AddIngredient";
import SearchInput from "../../../component/core/Searchinput";
import Addbutton from "../../../component/core/Addbuttons";
interface Ingredient {
  id: string;
  name: string;
}
const ListIngredients: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const chefId = currentUser?.uuid;
  const [showAddIngredient, setShowAddIngredient] = useState(false);
  const [showEditIngredient, setShowEditIngredient] = useState(false);
  const [editIngredientId, setEditIngredientId] = useState<string | null>(null);


  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showIngredient, setShowIngredient] = useState<any>(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");
  // useEffect to set the search term from URL (or local storage if needed)
  useEffect(() => {
    if (dataSearch !== null) {
      setSearch(dataSearch);
    }
  }, [dataSearch]);

  const filterData = {
    search: dataSearch,
  };



  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clickApply = (e: React.FormEvent) => {
    listIngredient();
    e.preventDefault();
    setCurrentPage(1);
  };

  const editCategory = (primaryId: string) => {
    navigate("/Categorys/edit/" + primaryId);
  };



  const [ingredient, setIngredient] = useState<Ingredient[]>([]);
  useEffect(() => {
    listIngredient();
  }, []);

  const listIngredient = () => {
    getIngredient(!chefId , search)
      .then((res) => {
        setIngredient(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching ingredients:", error);
      });
    setLoading(false)
  };

  const modalAddIngredient = () => {
    setShowAddIngredient(!showAddIngredient);
    listIngredient();
  };

  const modalEditIngredient = (id: string) => {
    setEditIngredientId(id); // Set the current ingredient ID
    setShowEditIngredient(true); // Open the modal
  };

  const handleEditModalClose = () => {
    setShowEditIngredient(false); // Close modal
    listIngredient(); // Refresh ingredient list
  };


  const deleteIngredient = (id: string) => {
    navigate("/ingredients/delete/" + id);
  };
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = ingredient.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(ingredient.length / itemsPerPage);


  const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1);

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            <section className="row main-content">
                         <Addbutton
  title="Ingredients"
  count={ingredient.length}
  searchValue={search}
  onSearchChange={handleSearchChange}
  onSearchKeyUp={clickApply}
  buttonText="Add Ingredients"
  buttonIcon="add_circle"
  onButtonClick={modalAddIngredient}
/>

              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={6} className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, i) => (
                        <tr key={item.id}>
                          <td>{indexOfFirstItem + i + 1}</td>
                          <td>
                            <p className="mb-0">{item.name}</p>
                          </td>
                          <td>
                            <div className="action-item">
                              <a
                                className="success cursorPointer me-5"
                                onClick={() => modalEditIngredient(item.id)} // Open edit modal
                              >
                                <span className="material-symbols-outlined">
                                  edit
                                </span>
                              </a>
                              <a
                                className="danger cursorPointer"
                                onClick={() => deleteIngredient(item.id)}
                              >
                                <span className="material-symbols-outlined">
                                  delete
                                </span>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={11} className="text-center">
                         No Ingredients Added – Start Creating Some!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Pagination
                data={ingredient}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>

            {/* Modal for Add Ingredients */}
            <AddIngredient show={showAddIngredient} onHide={modalAddIngredient} />
            {editIngredientId && (
              <EditIngredient
                show={showEditIngredient}
                onHide={handleEditModalClose} // Pass refresh onHide
                id={editIngredientId || ""}
              />
            )}
          </section>
        </div>
      </section>
    </>
  );
};

export default ListIngredients;
